'use client';

import { useEffect } from 'react';

import { DataTestIds } from '@repo/frontend-shared/data-test-ids';

/**
 * HydrationMarker
 *
 * This component sets a data attribute on the body tag when the component mounts on the client.
 * This allows E2E tests (Playwright) to explicitly wait for this attribute, ensuring that
 * React hydration is complete and the page is interactive before attempting actions.
 *
 * For SPAs (Vite), it signals that the initial mount is complete.
 * For Next.js, it signals that hydration is complete.
 */
export const HydrationMarker = () => {
  useEffect(() => {
    // Set the attribute to signal hydration/mount is complete
    document.body.setAttribute('data-hydrated', 'true');
    document.body.setAttribute('data-testid', DataTestIds.COMMON.APP_HYDRATED);
  }, []);

  return null;
};
